import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const GeneracionDemandaOmnicanal = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/01-Generación-de-Demanda-Omnicanal.pdf`;
  /*const pdfUrl = "/pdf/01-Generación-de-Demanda-Omnicanal.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Generación Demanda Omnicanal</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Generación Demanda Omnicanal" />
      </Container>
    </>
  );
};

 export default GeneracionDemandaOmnicanal;
